module.exports = __webpack_public_path__ + "static/media/importICloud3.8b55ee89.png";